export type Props = React.ComponentProps<'svg'>;

export default function IconGroup(props: Props) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.5 7.47754L12 12.1998M12 12.1998L3.49997 7.47754M12 12.1998L12 21.6998M21 16.2583V8.14124C21 7.79859 21 7.62727 20.9495 7.47447C20.9049 7.3393 20.8318 7.21522 20.7354 7.11053C20.6263 6.99219 20.4766 6.90899 20.177 6.74258L12.777 2.63147C12.4934 2.47392 12.3516 2.39514 12.2015 2.36425C12.0685 2.33692 11.9315 2.33692 11.7986 2.36425C11.6484 2.39514 11.5066 2.47392 11.223 2.63147L3.82297 6.74259C3.52345 6.90899 3.37369 6.99219 3.26463 7.11053C3.16816 7.21522 3.09515 7.3393 3.05048 7.47448C3 7.62727 3 7.7986 3 8.14124V16.2583C3 16.601 3 16.7723 3.05048 16.9251C3.09515 17.0603 3.16816 17.1844 3.26463 17.2891C3.37369 17.4074 3.52345 17.4906 3.82297 17.657L11.223 21.7681C11.5066 21.9257 11.6484 22.0044 11.7986 22.0353C11.9315 22.0627 12.0685 22.0627 12.2015 22.0353C12.3516 22.0044 12.4934 21.9257 12.777 21.7681L20.177 17.657C20.4766 17.4906 20.6263 17.4074 20.7354 17.2891C20.8318 17.1844 20.9049 17.0603 20.9495 16.9251C21 16.7723 21 16.601 21 16.2583Z"
        stroke="#84CAFF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5 9.69922L7.5 4.69922"
        stroke="#84CAFF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
